import React, { useState } from 'react';
import { Wallet, HandHeart, ShieldCheck, Sparkles } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const formatN = (n) => new Intl.NumberFormat('fr-FR').format(n || 0);
const fee = (a) => (a < 10000 ? 0 : a <= 100000 ? Math.round(a * 0.08) : Math.round(a * 0.03));

const TIERS = [
  { range: 'Moins de 10 000 FCFA', rate: 'GRATUIT', note: 'Aucun frais — 100 % du don va à la cagnotte', color: '#128C4A', highlight: true },
  { range: '10 000 à 100 000 FCFA', rate: '8 %', note: 'Frais déduits automatiquement du don', color: '#d97757' },
  { range: 'Plus de 100 000 FCFA', rate: '3 %', note: 'Tarif dégressif pour les grands élans de solidarité', color: '#0e3a3a' },
];

export default function TarifsPage() {
  const [amount, setAmount] = useState(15000);
  const f = fee(Number(amount) || 0);
  const net = (Number(amount) || 0) - f;

  return (
    <div className="min-h-screen bg-[#faf9f5]">
      <Header />
      <main className="pt-28 pb-20">
        <div className="max-w-[900px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-[11px] tracking-[0.18em] uppercase font-semibold text-[#d97757]">Transparence totale</div>
          <h1 className="mt-2 text-4xl sm:text-5xl font-semibold tracking-tight text-[#1a1d1a]">Frais &amp; Tarifs</h1>
          <p className="mt-3 text-[15px] text-neutral-600 max-w-[560px]">
            Pas de frais cachés, pas d'abonnement. Nos frais servent uniquement à sécuriser les paiements Mobile Money et à faire vivre la plateforme.
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-4">
            {TIERS.map((t) => (
              <div key={t.range} className={`rounded-3xl bg-white border p-6 ${t.highlight ? 'border-[#128C4A]/30 ring-2 ring-[#128C4A]/15' : 'border-black/5'}`} data-testid={`tarif-tier-${t.rate.replace(/\s|%/g, '')}`}>
                <div className="text-[12.5px] font-medium text-neutral-500">{t.range}</div>
                <div className="mt-2 text-[32px] font-semibold tracking-tight" style={{ color: t.color }}>{t.rate}</div>
                <p className="mt-2 text-[12.5px] text-neutral-600 leading-snug">{t.note}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 rounded-3xl bg-white border border-black/5 p-6 sm:p-8" data-testid="fee-simulator">
            <div className="flex items-center gap-2">
              <Wallet className="w-4.5 h-4.5 text-[#d97757]" />
              <h2 className="text-lg font-semibold text-[#1a1d1a]">Simulateur de frais</h2>
            </div>
            <div className="mt-4 grid sm:grid-cols-[1fr_auto_auto] gap-4 items-end">
              <div>
                <label className="text-[12.5px] font-medium text-neutral-600">Montant du don (FCFA)</label>
                <input
                  type="number"
                  min="100"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  data-testid="fee-simulator-input"
                  className="mt-1.5 w-full h-12 rounded-2xl bg-[#f5f4ef] px-4 text-[16px] font-semibold outline-none focus:ring-2 focus:ring-[#d97757]/40"
                />
              </div>
              <div className="text-center px-4">
                <div className="text-[11.5px] text-neutral-500">Frais</div>
                <div className="text-[20px] font-semibold text-[#d97757]" data-testid="fee-simulator-fee">{formatN(f)} FCFA</div>
              </div>
              <div className="text-center px-4 rounded-2xl bg-[#128C4A]/5 py-2">
                <div className="text-[11.5px] text-neutral-500">La cagnotte reçoit</div>
                <div className="text-[20px] font-semibold text-[#128C4A]" data-testid="fee-simulator-net">{formatN(net)} FCFA</div>
              </div>
            </div>
          </div>

          <div className="mt-10 grid sm:grid-cols-3 gap-4">
            <div className="rounded-3xl bg-white border border-black/5 p-5">
              <HandHeart className="w-5 h-5 text-[#d97757]" />
              <div className="mt-2 text-[13.5px] font-semibold text-[#1a1d1a]">Création gratuite</div>
              <p className="mt-1 text-[12.5px] text-neutral-600">Créer une cagnotte Joyeuse ou Yako ne coûte rien, sans limite de durée.</p>
            </div>
            <div className="rounded-3xl bg-white border border-black/5 p-5">
              <ShieldCheck className="w-5 h-5 text-[#5a8268]" />
              <div className="mt-2 text-[13.5px] font-semibold text-[#1a1d1a]">Retrait sécurisé</div>
              <p className="mt-1 text-[12.5px] text-neutral-600">Retrait vers Wave, Orange Money, MTN ou Moov protégé par biométrie ou code SMS.</p>
            </div>
            <div className="rounded-3xl bg-white border border-black/5 p-5">
              <Sparkles className="w-5 h-5 text-[#0e3a3a]" />
              <div className="mt-2 text-[13.5px] font-semibold text-[#1a1d1a]">Affichage transparent</div>
              <p className="mt-1 text-[12.5px] text-neutral-600">Le donateur voit les frais et le montant net reçu par la cagnotte avant de payer.</p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
